import { render } from "./PosterGenerator.vue?vue&type=template&id=0ee937ca&scoped=true"
import script from "./PosterGenerator.vue?vue&type=script&lang=js"
export * from "./PosterGenerator.vue?vue&type=script&lang=js"

import "./PosterGenerator.vue?vue&type=style&index=0&id=0ee937ca&scoped=true&lang=css"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee937ca"]])

export default __exports__